import { signUpDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const signUpCallable = getCallable(signUpDefinition);
